import React from "react"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"
import ParticipantProfileBoxSmall from "../../../components/ParticipantProfileBoxSmall"
import ListPageView from "../../../components/ListPageView"
import PropTypes from "prop-types"

function RenderLayout(props) {
  const { ID_TEMPLATE, ID_BLOCKS, listViewCols } = props

  const isParticipantRelated = [
    "custom_session_template_1",
    "custom_session_template_2",
    "custom_form_template_1",
    "custom_form_template_2",
  ]

  if (isParticipantRelated.includes(ID_TEMPLATE)) {
    return (
      <div className="layout-with-sidebar">
        <div className="sidebar">
          <ParticipantSidebar />
        </div>
        <div className="main-content">
          <ParticipantProfileBoxSmall />

          <ListPageView
            idTemplate={ID_TEMPLATE}
            idBlocks={ID_BLOCKS}
            columns={listViewCols}
            filterByParticipantId={true}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="theme-wrapper" style={{ background: "white" }}>
      <div className="sidebar"></div>
      <div className="main-content">
        <ListPageView
          idTemplate={ID_TEMPLATE}
          idBlocks={ID_BLOCKS}
          columns={listViewCols}
        />
      </div>
    </div>
  )
}

RenderLayout.propTypes = {
  ID_TEMPLATE: PropTypes.string.isRequired,
  ID_BLOCKS: PropTypes.array.isRequired,
  listViewCols: PropTypes.array.isRequired,
}

export default RenderLayout
